export default __webpack_public_path__ + "maps-examples-view-annotation-marker-1200-0048cf397ffc5904257c968da0a2c87b.png";